export default {
  media: {
    image: 'Imagem'
  }
}
